module.exports = __webpack_public_path__ + "img/WalletorRetur.9d270c6b.svg";